/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Add supplier note
 */
export const AddSupplierNoteBody = zod.object({
  title: zod.string(),
  content: zod.string(),
});

export const AddSupplierNoteResponse = zod.int().describe("Note identity.");

/**
 * @summary Edit supplier note
 */
export const EditSupplierNoteBody = zod.object({
  title: zod.string(),
  content: zod.string(),
});

export const EditSupplierNoteResponse = zod.void();

/**
 * @summary Remove supplier note
 */
export const RemoveSupplierNoteResponse = zod.void();
